import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function CardCursos(props) {
  return (
    <div className="w-full rounded-lg rounded-tl-none bg-yellow-50 relative overflow-hidden group flex flex-col">
      <div className="h-[200px] sm:h-[225px] md:h-[250px] xl:h-[280px] overflow-hidden rounded-b-[20px]">
        <img
          src={props.img}
          alt={props.descripcion}
          className="object-cover object-center w-full h-full group-hover:motion-safe:scale-110 transition-all duration-300 ease-in-out "
        />
      </div>
      <div className="flex flex-col text-left p-2 sm:p-4 md:p-4 xl:p-5 text-white gap-2 w-full">
        <h3 className=" font-bold text-blue-4 md:text-xl 2xl:text-2xl">
          {props.curso}
        </h3>
        <p className=" text-sm  text-black lg:text-base hyphens-none">{props.descripcion}</p>
        {props.url ? (
          <Link
            to={props.url}
            className="text-sm md:text-base self-end place-items-end px-4 py-2 bg-blue-4 rounded-full rounded  rounded-tr-none text-white hover:bg-gray-500 justify-self-end"
          >
            {" "}
            Ver más
          </Link>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default CardCursos;
